
import Fade from 'react-reveal/Fade'

export default function Header() {
	return (
		<Fade>
			<header className="bg-rose-600">
			<nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Top">
				<div className="w-full py-6 flex items-center justify-between border-b border-rose-500 lg:border-none">
					<div className="flex items-center">
						<a href="#Home">
							<img
								className="h-10 w-auto logo_white"
								src={process.env.PUBLIC_URL + '/logo.png'}
								style={{ filter: 'brightness(0) invert(1)' }}
								alt=""
							/>
						</a>
					</div>
					<div className="ml-10 space-x-4">
						<a
							href="/signin"
							className="inline-block bg-rose-500 py-2 px-6 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75"
						>
							Sign in
						</a>
						<a
							href="signup"
							className="inline-block bg-white py-2 px-6 border border-transparent rounded-md text-base font-medium text-rose-600 hover:bg-rose-50"
						>
							Sign up
						</a>
					</div>
				</div>
			</nav>
		</header>
		</Fade>
		
	);
}
